module.exports = __webpack_public_path__ + "img/logo-white.124a7190.png";